module.exports = __webpack_public_path__ + "img/iconver1_blackwhite.8722e195.png";